<template>

  <div class="category-list">
    <div v-if="list.length > 0">
      <div
        v-for="(item, index) in list"
        :key="index"
      >
        <categoryCard
          :item="item"
          :index="index"
          @click="selectClick"
        />
      </div>
    </div>
    <div
      v-else
      class="blank-wrap"
    >
      <Blank />
    </div>
  </div>
</template>

  <script >

import categoryCard from './components/category-card.vue';
import { learningArticleTypes } from '@/common/apiGeneral.js';
import Blank from '@/components/blank.vue';
import jsApi from '@/common/jsApi';
export default {
  components: {
    categoryCard,
    Blank
  },
  data() {
    return {
      list: []
    };
  },
  created() {
    // 定义提供给原生调用的方法
    window.webViewDidAppear = () => {
      console.log('文章分类webViewDidAppear()');
      this.queryLearningArticleTypes();
    };
  },
  mounted() {
    this.queryLearningArticleTypes();
  },
  methods: {

    async queryLearningArticleTypes() {
      if (this.list.length < 1) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const res = await learningArticleTypes({});
        if (res) {
          this.list = res;
        }
        this.$toast.clear();
      } catch (error) {
        this.$toast.clear();
        console.log(error);
      }
    },
    selectClick(item) {
      //   this.$router.push({
      //     name: 'articleList',
      //     query: {
      //       articleType: item.articleType
      //     }
      //   });

      const url = window.location.href.split('#')[0];
      const detailUrl = url + `#/articleList?articleType=${item.articleType}`;
      console.log('detailUrl', detailUrl);

      jsApi.openWebView({
        url: detailUrl,
        title: '系统操作'
      });
    }
  }
};

  </script>

<style lang="scss" scoped>

.category-list {
  min-height: 100vh;
  padding: 12px;
  background-color: #f2f3f5;

  .blank-wrap {
    padding-top: 230px;
  }
}
</style>
